import { Invoice, InvoiceAllocation } from '@/services/types/invoice.types';

type AllocationEntry = NonNullable<InvoiceAllocation['allocation_department_ac']>[number];

export type InvoiceAllocationAmountKey = keyof Pick<
  InvoiceAllocation,
  | 'allocation_department_ac'
  | 'allocation_productAndServices_ac'
  | 'allocation_project_ac'
  | 'allocation_contract_ac'
  | 'allocation_expense_category'
  | 'allocation_revenue_category'
  | 'allocation_bank_account'
>;

export function withPaymentAmountFromAllocationKey(
  invoice: Invoice,
  entityId: string,
  allocationKey: InvoiceAllocationAmountKey
): Invoice {
  const list = invoice.allocations?.[allocationKey];
  const match = list?.find((a) => a.id === entityId);
  if (match === undefined) return invoice;
  return { ...invoice, payment_amount: match.value };
}

export function getAllocationListForAcType(
  allocations: InvoiceAllocation | undefined,
  acTypeParam: string | undefined
): AllocationEntry[] | undefined {
  if (!allocations || !acTypeParam) return undefined;
  const t = acTypeParam.toUpperCase();
  switch (t) {
    case 'DEPARTMENT_ACCOUNTING':
      return allocations.allocation_department_ac;
    case 'PRODUCTS_AND_SERVICES':
      return allocations.allocation_productAndServices_ac;
    case 'PROJECTS':
      return allocations.allocation_project_ac;
    case 'CONTRACTS':
      return allocations.allocation_contract_ac;
    default:
      return undefined;
  }
}

export function withPaymentAmountFromAcAllocation(
  invoice: Invoice,
  acId: string,
  acTypeParam: string | undefined
): Invoice {
  const list = getAllocationListForAcType(invoice.allocations, acTypeParam);
  const match = list?.find((a) => a.id === acId);
  if (match === undefined) return invoice;
  return { ...invoice, payment_amount: match.value };
}
